// extracted by mini-css-extract-plugin
export default {"container":"plate_container__hM7xI","vehicle":"plate_vehicle__vtbTk","bike":"plate_bike__IU14A"};